import { useState } from 'react';

export const useSorting = (initialOrderBy = '', initialOrderDesc = false) => {
    const [orderBy, setOrderBy] = useState(initialOrderBy);
    const [orderDesc, setOrderDesc] = useState(initialOrderDesc);

    const handleSort = (column) => {
        if (orderBy === column) {
            if (!orderDesc) {
                setOrderDesc(true);
            } else {
                setOrderBy('');
                setOrderDesc(false);
            }
        } else {
            setOrderBy(column);
            setOrderDesc(false);
        }
    };

    const getSortIcon = (column) => {
        if (orderBy !== column) return '⇅';
        return orderDesc ? '▾' : '▴';
    };

    const resetSort = () => {
        setOrderBy('');
        setOrderDesc(false);
    };

    return {
        orderBy,
        orderDesc,
        handleSort,
        getSortIcon,
        resetSort
    };
};